<template>
  <div>
    <div class="panel-body">
      <div class="row">
        <div class="col-md-8" v-if="resource">
          <template v-if="showResource">
            <template v-for="item in companiesHouseChanges">
              <div class="alert" :class="{'alert-danger': !item.processed, 'alert-success': item.processed}">
                <p>{{item.description}}</p>
                <p><a :href="item.url" target="_blank">View resource</a></p>
                <p><a type="button" class="link" @click="markAsProcessed(item.id)">Mark processed</a></p>
              </div>
            </template>
          </template>

          <pagination :response="meta" @setPage="getCompaniesHouseChangesDataSaved"></pagination>

        </div>
        <div class="col-md-8" v-else>
          <div class="col-xs-12">
            <label class="control-label">Companies House Number</label>
            <div class="input-group">
              <input
                  type="text"
                  class="form-control"
                  name="companies_house_number"
                  id="companies_house_number"
                  placeholder="What is your Companies House Number?"
                  v-model="companiesHouseNumber"
                  :disabled="accountId !== 0"
              />
              <span class="input-group-btn">
          <button :disabled="accountId !== 0" class="btn btn-default" type="button" style="height: 40px;" v-on:click="getCompaniesHouseData">
            <i class="fa fa-refresh" id="get_companies_house"></i>
          </button>
        </span>
            </div>
            <span v-if="companiesHouse.errors">
          <p v-for="error in companiesHouse.errors">{{error.error}}</p>
        </span>
          </div>
          <div v-if="showInfo">
            <div class="col-md-12">
              <hr>
            </div>
            <div class="col-md-12">
              <div class="col-md-4">
                <p>
                  Name
                </p>
              </div>
              <div class="col-md-8">
                <p>
                  {{ companiesHouse.company_name }}
                </p>
              </div>
            </div>

            <div class="col-md-12">
              <hr>
            </div>

            <div class="col-md-12">
              <div class="col-md-4">
                <p>
                  Company Registration No.
                </p>
              </div>
              <div class="col-md-8">
                <p>
                  {{ companiesHouse.company_number }}
                </p>
              </div>
            </div>

            <div class="col-md-12">
              <hr>
            </div>

            <div class="col-md-12">
              <div class="col-md-4">
                <p>
                  Registered Address
                </p>
              </div>
              <div class="col-md-8">
                <p>
                  {{ companiesHouse.company_address.address_line_1 }}
                </p>
                <p>
                  {{ companiesHouse.company_address.address_line_2 }}
                </p>
                <p>
                  {{ companiesHouse.company_address.country }}
                </p>
                <p>
                  {{ companiesHouse.company_address.postal_code }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4" v-if="showInfo">
          <ul class="list-group">
            <li class="list-group-item"><a href="/companies-house-changes/companies">Company information</a><span class="badge" :class="{ 'badge-error': (companiesHouse.companies_house_changes?.companies?.unprocessed) ?? 0 > 0 }">{{companiesHouse.companies_house_changes?.companies?.all ?? 0}}</span></li>
            <li class="list-group-item"><a href="/companies-house-changes/filings">Filing history</a><span class="badge" :class="{ 'badge-error': (companiesHouse.companies_house_changes?.filings?.unprocessed ?? 0) > 0 }">{{companiesHouse.companies_house_changes?.filings?.all ?? 0}}</span></li>
            <li class="list-group-item"><a href="/companies-house-changes/insolvency_cases">Insolvency cases</a><span class="badge" :class="{ 'badge-error': (companiesHouse.companies_house_changes?.insolvency_cases?.unprocessed ?? 0) > 0 }">{{companiesHouse.companies_house_changes?.insolvency_cases?.all ?? 0}}</span></li>
            <li class="list-group-item"><a href="/companies-house-changes/charges">Charges</a><span class="badge" :class="{ 'badge-error': (companiesHouse.companies_house_changes?.charges?.unprocessed ?? 0) > 0 }">{{companiesHouse.companies_house_changes?.charges?.all ?? 0}}</span></li>
            <li class="list-group-item"><a href="/companies-house-changes/officers">Officers</a><span class="badge" :class="{ 'badge-error': (companiesHouse.companies_house_changes?.officers?.unprocessed ?? 0) > 0 }">{{companiesHouse.companies_house_changes?.officers?.all ?? 0}}</span></li>
            <li class="list-group-item"><a href="/companies-house-changes/persons_with_significant_control">Persons with significant control</a><span class="badge" :class="{ 'badge-error': (companiesHouse.companies_house_changes?.persons_with_significant_control?.unprocessed ?? 0) > 0 }">{{companiesHouse.companies_house_changes?.persons_with_significant_control?.all ?? 0}}</span></li>
            <li class="list-group-item"><a href="/companies-house-changes/disqualified_officers">Disqualified officers</a><span class="badge" :class="{ 'badge-error': (companiesHouse.companies_house_changes?.disqualified_officers?.unprocessed ?? 0) > 0 }">{{companiesHouse.companies_house_changes?.disqualified_officers?.all ?? 0}}</span></li>
            <li class="list-group-item"><a href="/companies-house-changes/company_exemptions">Company exemptions</a><span class="badge" :class="{ 'badge-error': (companiesHouse.companies_house_changes?.company_exemptions?.unprocessed ?? 0) > 0 }">{{companiesHouse.companies_house_changes?.company_exemptions?.all ?? 0}}</span></li>
            <li class="list-group-item"><a href="/companies-house-changes/persons_with_significant_control_statements">Persons with significant control statements</a><span class="badge" :class="{ 'badge-error': (companiesHouse.companies_house_changes?.persons_with_significant_control_statements?.unprocessed ?? 0) > 0 }">{{companiesHouse.companies_house_changes?.persons_with_significant_control_statements?.all ?? 0}}</span></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="panel-footer">
      <div class="row">
        <div class="col-xs-6">
          <a :href="previousPage" class="btn btn-primary">Back</a>
        </div>
        <div class="col-xs-6">
          <button type="button" class="btn btn-primary submit pull-right" v-on:click="saveData" v-if="showButtonSave">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompaniesHouseInfoComponent",

  // props: ['csrfToken', 'previousPage'],
  props: {
    csrfToken: {
      required: true,
      type: String,
    },
    previousPage: {
      required: true,
      type: String,
    },
    accountId: {
      required: true,
      type: Number,
    },
    resource: {
      required: false,
      type: String,
      default: null,
    },
  },
  data() {
    return {
      companiesHouse: {
        company_address: {},
        companies_house_changes: {},
      },
      companiesHouseNumber: null,
      showInfo: false,
      showResource: false,
      showButtonSave: false,
      companiesHouseChanges: {},
      meta: {},
      page: null,
      thisPage: null
    }
  },
  mounted() {},
  methods: {
    getCompaniesHouseData() {
      this.showInfo = false;
      this.inProcess(true);
      axios.get(`/companies-house-short-info/${this.companiesHouseNumber}`).then((res) => {
        this.companiesHouse = res.data;
        this.inProcess(false);
        if (!this.companiesHouse.errors) {
          this.showInfo = true;
          this.showButtonSave = true;
        }
      }).catch((error) => {
        console.log('error', error)
        this.inProcess(false);
      })
    },
    saveData() {
      this.showButtonSave = false;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = this.csrfToken;
      axios.post(`/process-companies-house-data`, {'companies_house_number': this.companiesHouseNumber})
          .then((res) => {
            this.getCompaniesHouseDataSaved();
          })
          .catch((error) => {
            console.log('error', error)
            this.showButtonSave = true;
          })
    },
    getCompaniesHouseDataSaved() {
      this.showInfo = false;
      const path = this.accountId ? `/member-firm/${this.accountId}/companies-house-short-info-saved` : '/companies-house-short-info-saved';
      axios.get(path).then((res) => {
        this.companiesHouseNumber = res.data.companies_house_number
        this.companiesHouse.company_number = res.data.companies_house_number;
        this.companiesHouse.company_name = res.data.companies_house.company_name;
        this.companiesHouse.company_address.address_line_1 = res.data.companies_house.registered_office_address_line_1;
        this.companiesHouse.company_address.address_line_2 = res.data.companies_house.registered_office_address_line_2;
        this.companiesHouse.company_address.country = res.data.companies_house.registered_office_country;
        this.companiesHouse.company_address.postal_code = res.data.companies_house.registered_office_postal_code;
        this.companiesHouse.companies_house_changes.companies = res.data.companies_house_changes.companies;
        this.companiesHouse.companies_house_changes.filings = res.data.companies_house_changes.filings;
        this.companiesHouse.companies_house_changes.insolvency_cases = res.data.companies_house_changes.insolvency_cases;
        this.companiesHouse.companies_house_changes.charges = res.data.companies_house_changes.charges;
        this.companiesHouse.companies_house_changes.officers = res.data.companies_house_changes.officers;
        this.companiesHouse.companies_house_changes.persons_with_significant_control = res.data.companies_house_changes.persons_with_significant_control;
        this.companiesHouse.companies_house_changes.disqualified_officers = res.data.companies_house_changes.disqualified_officers;
        this.companiesHouse.companies_house_changes.company_exemptions = res.data.companies_house_changes.company_exemptions;
        this.companiesHouse.companies_house_changes.persons_with_significant_control_statements = res.data.companies_house_changes.persons_with_significant_control_statements;
        this.showInfo = true;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    inProcess(process) {
      const icon = document.getElementById('get_companies_house');
      if (process) {
        icon.classList.add("fa-spin");
      } else {
        icon.classList.remove("fa-spin");
      }
    },
    getCompaniesHouseChangesDataSaved(page = null) {
      this.thisPage = page;
      this.showResource = false;
      const path = this.accountId ? `/member-firm/${this.accountId}/companies-house-changes-saved?page=${page}` : `/companies-house-changes-saved/${this.resource}?page=${page}`;
      axios.get(path).then((res) => {
        this.companiesHouseChanges = res.data.data;
        this.meta = res.data.meta;
        this.showResource = true;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    markAsProcessed(id) {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = this.csrfToken;
      axios.post(`/companies-house-changes-mark-as-processed-data`, {'companies_house_changes_id': id})
          .then((res) => {
            this.getCompaniesHouseChangesDataSaved(this.thisPage);
          })
          .catch((error) => {
            console.log('error', error)
          })
    },
  },
  created() {
    this.getCompaniesHouseDataSaved();
    if (this.resource) {
      this.getCompaniesHouseChangesDataSaved();
    }
  }
}
</script>

<style scoped>
.badge:hover {
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
}
.badge-error {
  background-color: #b94a48;
}
.badge-error:hover {
  background-color: #953b39;
}
</style>